/**
 * The header the four scoped dashboard pages share: the page's name, and the
 * region picker beside it.
 *
 * One component rather than four copies of the same four lines, because the
 * only thing that differs between Sales, Teachers, Supplies and Corp Events is
 * the title and which path the picker addresses.
 */
import { useViewport } from '../../../hooks/useViewport';
import { DashboardPageHeader } from '../primitives/DashboardPageHeader';
import { queryRegionHref } from '../primitives/scope/query-region-href';
import { ScopePicker } from '../primitives/scope/ScopePicker';

import type { DashboardScope } from './dashboard-scope';

export interface DashboardScopeHeaderProps {
  title: string;
  /** The page's own route, which the picker writes `?region=` onto. */
  basePath: string;
  scope: DashboardScope;
}

export function DashboardScopeHeader({ title, basePath, scope }: DashboardScopeHeaderProps) {
  const { isPhone } = useViewport();
  const hrefFor = queryRegionHref(basePath);

  return (
    <DashboardPageHeader
      title={title}
      isPhone={isPhone}
      scope={
        <ScopePicker
          label={scope.label}
          currentRegionId={scope.currentRegionId}
          regions={scope.regions}
          hrefFor={hrefFor}
          isPhone={isPhone}
          showAllRegions={scope.canReadNational}
        />
      }
    />
  );
}
